import axiosClient from "./axiosClient";

export const getLotteryResult = async ({ lotteryType, filterDate }) => {
    const response = await axiosClient.get(
        `/api/v1.0.0/${lotteryType.toUpperCase()}/result-v2`,
        {
            params: {
                filterByDate: filterDate,
            },
        }
    );

    if (Array.isArray(response)) {
        return response;
    }

    if (Array.isArray(response?.data)) {
        return response.data;
    }

    return [];
};
